import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/">SmartCart</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/shopping-lists">Einkaufslisten</Nav.Link>
              <Nav.Link as={Link} to="/product-search">Produktmonitor</Nav.Link>
              <Nav.Link as={Link} to="/receipts">Kassenbons</Nav.Link>
              <Nav.Link as={Link} to="/settings">Einstellungen</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container className="mt-3">
        {children}
      </Container>
    </>
  );
};

export default Layout;
